<template>
  <div class="product_module">
    <div class="product_bag">
      <product-banner></product-banner>
    </div>
    <div class="product_bag">
      <product-body></product-body>
    </div>
  </div>
</template>
<script>
import productBanner from './productBanner';
import productBody from './productBody';
export default {
  data() {
    return {
      productArr: [
        {
          childArr: [
            {
              path: '',
              title: 'qwqwqwqw',
              index: 1
            },
            {
              path: '',
              title: 'ererererer',
              index: 2
            },
            {
              path: '',
              title: '9999999',
              index: 3
            }
          ],
          index: 1
        },
        {
          childArr: [
            {
              path: '',
              title: 'dfddfdfd',
              index: 4
            },
            {
              path: '',
              title: '555555',
              index: 5
            }
          ],
          index: 2
        },
        {
          childArr: [
            {
              path: '',
              title: '8888888',
              index: 6
            },
            {
              path: '',
              title: '',
              index: 7
            }
          ],
          index: 3
        }
      ],
      activeIndex2: '',
      currentDate: ''
    };
  },
  components: {
    productBanner,
    productBody
  },
  methods: {}
};
</script>
<style scoped>
.product_module {
  width: 100%;
  min-height: 600px;
}
.product_bag {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/product/product.vue